import styled from 'styled-components';
import { media } from 'modules/common/components/ui/utils';

const SearchContainer = styled.div`
  padding: 0 1rem;
  margin: 0 auto 0;
  position: relative;
  text-align: center;
  width: 100%;
  max-width: calc(630rem / 16);
  box-sizing: border-box;
  ${media.tabletNarrow`
    position: relative;
    width: 100%;
    padding: 0 1rem;
  `}
  ${media.minWidth(1200)`
    padding-top: 6.125rem;
    padding-bottom: 1.5rem;
  `}
  h1{
    font-size: calc(22rem / 16);
    font-weight: 100;
    margin-top: 0;
    ${media.tabletNarrow`
      font-size: calc(34rem / 16);
    `}
  }
`;

export default SearchContainer;



// WEBPACK FOOTER //
// ./src/modules/search/ui/SearchContainer.js